import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationFindingTarget = createCrudVuexModule({
  namespaced: true,
  path: "/finding-target",
  options: { localizedFields: ["name", "description", "criticality"] },

  state: {},

  mutations: {},

  actions: {
    async fetchTarget({ commit, state }, payload) {
      try {
        commit("isLoading", true);
        const response = await rest.get(`/finding-target`);
        commit("selectedEntity", response.data);
        return response.data;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});
